"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagesApi = exports.ImagesApiFactory = exports.ImagesApiFp = exports.ImagesApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * ImagesApi - axios parameter creator
 * @export
 */
const ImagesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} uploadedFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesResourceGetImage: (uploadedFileId_1, ...args_1) => __awaiter(this, [uploadedFileId_1, ...args_1], void 0, function* (uploadedFileId, options = {}) {
            // verify required parameter 'uploadedFileId' is not null or undefined
            (0, common_1.assertParamExists)('imagesResourceGetImage', 'uploadedFileId', uploadedFileId);
            const localVarPath = `/images/{uploadedFileId}`
                .replace(`{${"uploadedFileId"}}`, encodeURIComponent(String(uploadedFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesResourceUploadImage: (...args_2) => __awaiter(this, [...args_2], void 0, function* (options = {}) {
            const localVarPath = `/images/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ImagesApiAxiosParamCreator = ImagesApiAxiosParamCreator;
/**
 * ImagesApi - functional programming interface
 * @export
 */
const ImagesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ImagesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} uploadedFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesResourceGetImage(uploadedFileId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imagesResourceGetImage(uploadedFileId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ImagesApi.imagesResourceGetImage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesResourceUploadImage(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imagesResourceUploadImage(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ImagesApi.imagesResourceUploadImage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.ImagesApiFp = ImagesApiFp;
/**
 * ImagesApi - factory interface
 * @export
 */
const ImagesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ImagesApiFp)(configuration);
    return {
        /**
         *
         * @param {ImagesApiImagesResourceGetImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesResourceGetImage(requestParameters, options) {
            return localVarFp.imagesResourceGetImage(requestParameters.uploadedFileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesResourceUploadImage(options) {
            return localVarFp.imagesResourceUploadImage(options).then((request) => request(axios, basePath));
        },
    };
};
exports.ImagesApiFactory = ImagesApiFactory;
/**
 * ImagesApi - object-oriented interface
 * @export
 * @class ImagesApi
 * @extends {BaseAPI}
 */
class ImagesApi extends base_1.BaseAPI {
    /**
     *
     * @param {ImagesApiImagesResourceGetImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    imagesResourceGetImage(requestParameters, options) {
        return (0, exports.ImagesApiFp)(this.configuration).imagesResourceGetImage(requestParameters.uploadedFileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    imagesResourceUploadImage(options) {
        return (0, exports.ImagesApiFp)(this.configuration).imagesResourceUploadImage(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ImagesApi = ImagesApi;
//# sourceMappingURL=images-api.js.map